import { apiFetch, getCurrentUser } from './index.js';

const api = {
    // =====================================================
    // MÉTODOS DE SERVICIOS EXTERNOS
    // =====================================================

    obtenerServicios: async () => {
        try {
            const res = await apiFetch('/ServiciosExternos');
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en obtenerServicios:", error);
            return { success: false, message: error.message || 'Error al obtener servicios' };
        }
    },

    obtenerServicioPorId: async (id) => {
        try {
            const res = await apiFetch(`/ServiciosExternos/${id}`);
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en obtenerServicioPorId:", error);
            return { success: false, message: error.message || 'Error al obtener servicio' };
        }
    },

    crearServicio: async (payload) => {
        try {
            console.log('📝 Creando servicio con payload:', payload);
            const res = await apiFetch('/ServiciosExternos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en crearServicio:", error);
            let errorMessage = error.message || 'Error al crear servicio';
            if (error.response?.data?.errors) {
                const errors = error.response.data.errors;
                errorMessage = Object.values(errors).flat().join(', ');
            } else if (error.response?.data?.mensaje) {
                errorMessage = error.response.data.mensaje;
            }
            return { success: false, message: errorMessage };
        }
    },

    // ✅ CORREGIDO: Usar PUT con el payload correcto
    actualizarServicio: async (id, payload) => {
        try {
            console.log(`🔍 Actualizando servicio ${id} con PUT`);
            console.log('📦 Payload:', JSON.stringify(payload, null, 2));
            
            // ✅ Asegurarnos de que el payload tenga solo los campos permitidos
            const camposPermitidos = {
                idServicioExterno: id || payload.idServicioExterno || null,
                idCliente: payload.idCliente,
                idTecnico: payload.idTecnico,
                descripcion: payload.descripcion,
                direccion: payload.direccion,
                ubicacionGps: payload.ubicacionGps,
                costo: payload.costo,
                prioridad: payload.prioridad,
                observaciones: payload.observaciones,
                fechaProgramada: payload.fechaProgramada,
                fechaFinalizacion: payload.fechaFinalizacion,
                fechaPago: payload.fechaPago,
                estado: payload.estado,
                metodoPago: payload.metodoPago,
                referenciaPago: payload.referenciaPago,
                montoPagado: payload.montoPagado,
                // Para crédito - enviar solo si existen
                idCreditoServicioExterno: payload.idCreditoServicioExterno || null,
                estadoCredito: payload.estadoCredito || null,
                fechaPagoAcordada: payload.fechaPagoAcordada || null
            };

            // Eliminar campos undefined
            Object.keys(camposPermitidos).forEach(key => {
                if (camposPermitidos[key] === undefined) {
                    delete camposPermitidos[key];
                }
            });

            const res = await apiFetch(`/ServiciosExternos/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(camposPermitidos)
            });
            console.log('✅ Respuesta:', res);
            return { success: true, data: res };
        } catch (error) {
            console.error("❌ Error en actualizarServicio:", error);
            console.error("❌ Status:", error.status);
            console.error("❌ Response:", error.response?.data);
            
            let errorMessage = error.message || 'Error al actualizar servicio';
            if (error.response?.data) {
                if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                } else if (error.response.data.mensaje) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.response.data.errors) {
                    const errors = error.response.data.errors;
                    errorMessage = Object.values(errors).flat().join(', ');
                } else {
                    errorMessage = JSON.stringify(error.response.data);
                }
            }
            return { success: false, message: errorMessage };
        }
    },

    actualizarEstado: async (id, nuevoEstado) => {
        try {
            const res = await apiFetch(`/ServiciosExternos/${id}/estado`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(nuevoEstado)
            });
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en actualizarEstado:", error);
            return { success: false, message: error.message || 'Error al actualizar estado' };
        }
    },

    eliminarServicio: async (id) => {
        try {
            const res = await apiFetch(`/ServiciosExternos/${id}`, {
                method: 'DELETE'
            });
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en eliminarServicio:", error);
            return { success: false, message: error.message || 'Error al eliminar servicio' };
        }
    },

    // =====================================================
    // ⭐ NUEVOS: MÉTODOS PARA DETALLES (productos/servicios)
    // =====================================================

    agregarDetalle: async (idServicio, detalleDTO) => {
        try {
            console.log(`📤 Agregando detalle al servicio ${idServicio}:`, detalleDTO);
            const res = await apiFetch(`/ServiciosExternos/${idServicio}/detalles`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(detalleDTO)
            });
            console.log('✅ Detalle agregado:', res);
            return { success: true, data: res };
        } catch (error) {
            console.error("❌ Error en agregarDetalle:", error);
            let errorMessage = error.message || 'Error al agregar el detalle';
            if (error.response?.data?.mensaje) {
                errorMessage = error.response.data.mensaje;
            } else if (error.response?.data?.errors) {
                const errors = error.response.data.errors;
                errorMessage = Object.values(errors).flat().join(', ');
            }
            return { success: false, message: errorMessage };
        }
    },

    eliminarDetalle: async (idDetalle) => {
        try {
            console.log(`🗑️ Eliminando detalle ${idDetalle}`);
            await apiFetch(`/ServiciosExternos/detalles/${idDetalle}`, {
                method: 'DELETE'
            });
            return { success: true };
        } catch (error) {
            console.error("❌ Error en eliminarDetalle:", error);
            return { success: false, message: error.message || 'Error al eliminar el detalle' };
        }
    },

    obtenerDetalles: async (idServicio) => {
        try {
            const res = await apiFetch(`/ServiciosExternos/${idServicio}/detalles`);
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en obtenerDetalles:", error);
            return { success: false, message: error.message, data: [] };
        }
    },

    // =====================================================

    registrarPagoCaja: async (servicio, pagoData) => {
        try {
            const currentUser = getCurrentUser();
            if (!currentUser || !currentUser.idUsuario) {
                return { success: false, message: 'Usuario no autenticado' };
            }

            const movimientoCaja = {
                tipoMovimiento: "Ingreso",
                montoUsd: pagoData.monto || 0,
                montoBs: pagoData.monedaOriginal === 'VES' ? pagoData.montoOriginal : 0,
                descripcion: `Cobro de servicio externo: ${servicio.descripcion || servicio.descripcionServicio || 'Servicio a Domicilio'} - Cliente: ${servicio.nombreCliente || 'N/A'} - Método: ${pagoData.metodo || 'Efectivo'} (Ref: ${pagoData.referencia || 'N/A'})`,
                fechaMovimiento: new Date().toISOString(),
                idUsuario: currentUser.idUsuario
            };

            const res = await apiFetch('/MovimientoCaja', {
                method: 'POST',
                body: JSON.stringify(movimientoCaja)
            });
            
            return { success: true, data: res };
        } catch (error) {
            console.error("Error registrando pago en caja:", error);
            return { success: false, message: error.message };
        }
    },

    // ✅ CORREGIDO: Ahora usa el endpoint de crédito para registrar la fecha/hora real del pago
    abonarServicioExterno: async (id, montoAbonar, metodoPago, referencia, fechaPago = null) => {
        try {
            const currentUser = getCurrentUser();
            const fechaPagoReal = fechaPago || new Date().toISOString();
            
            const resGet = await apiFetch(`/ServiciosExternos/${id}`);
            const servicio = resGet.data || resGet;
            
            let creditoInfo = null;
            try {
                const resCredito = await apiFetch(`/CreditoServicioExterno/resumen/servicio/${id}`);
                creditoInfo = resCredito.data || resCredito;
            } catch (e) {
                console.log('ℹ️ El servicio no tiene crédito asociado, usando flujo normal');
            }
            
            let res;
            let flujoUsado = '';
            
            if (creditoInfo && creditoInfo.idCreditoServicioExterno) {
                console.log('💰 Registrando pago vía CreditoServicioExterno:', creditoInfo.idCreditoServicioExterno);
                flujoUsado = 'credito';
                
                const idCredito = creditoInfo.idCreditoServicioExterno;
                
                res = await apiFetch(`/CreditoServicioExterno/${idCredito}/pagar`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        montoPagoUsd: montoAbonar,
                        montoPagoBs: 0,
                        fechaPago: fechaPagoReal,
                        metodoPago: metodoPago || 'Efectivo',
                        referencia: referencia || '',
                        observaciones: `Abono desde gestión de créditos`
                    })
                });
            } else {
                console.log('📝 Servicio sin crédito, usando PUT normal');
                flujoUsado = 'put';
                
                const nuevoMonto = (servicio.montoPagado || 0) + montoAbonar;
                const payload = {
                    idServicioExterno: id,
                    idCliente: servicio.idCliente,
                    idTecnico: servicio.idTecnico,
                    descripcion: servicio.descripcion,
                    direccion: servicio.direccion,
                    ubicacionGps: servicio.ubicacionGps,
                    costo: servicio.costo,
                    prioridad: servicio.prioridad,
                    observaciones: servicio.observaciones,
                    fechaProgramada: servicio.fechaProgramada,
                    fechaFinalizacion: servicio.fechaFinalizacion,
                    fechaPago: fechaPagoReal,
                    estado: (servicio.costo - nuevoMonto) <= 0 ? 'COMPLETADO' : servicio.estado,
                    metodoPago: metodoPago || servicio.metodoPago,
                    referenciaPago: referencia || servicio.referenciaPago,
                    montoPagado: nuevoMonto
                };
                
                res = await apiFetch(`/ServiciosExternos/${id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });
            }
            
            const movimientoCaja = {
                tipoMovimiento: "Ingreso",
                montoUsd: montoAbonar,
                montoBs: 0,
                descripcion: `Abono Crédito Servicio a Domicilio #${servicio.numeroServicio || id} - Cliente: ${servicio.nombreCliente || 'N/A'} - Método: ${metodoPago} (Ref: ${referencia || 'N/A'})`,
                fechaMovimiento: fechaPagoReal,
                idUsuario: currentUser?.idUsuario || 1
            };

            await apiFetch('/MovimientoCaja', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(movimientoCaja)
            });

            console.log(`✅ Pago registrado vía ${flujoUsado}`);
            return { success: true, data: res };
        } catch(e) {
            console.error("❌ Error abonando servicio externo:", e);
            return { success: false, error: e.message };
        }
    },

    // =====================================================
    // MÉTODOS DE CRÉDITO PARA SERVICIOS EXTERNOS
    // =====================================================

    crearCreditoServicioExterno: async (creditoData) => {
        try {
            const payload = {
                idServicioExterno: creditoData.idServicioExterno,
                codigoTipoCredito: creditoData.codigoTipoCredito || 'EMP-001',
                numeroCuotas: creditoData.numeroCuotas || 1,
                fechaVencimientoBase: creditoData.fechaVencimientoBase || null,
                observaciones: creditoData.observaciones || ''
            };

            console.log('📝 Enviando al backend (CreditoServicioExterno):', JSON.stringify(payload, null, 2));

            const response = await apiFetch('/CreditoServicioExterno', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            
            console.log('✅ Respuesta del backend:', response);
            
            return {
                success: true,
                data: response,
                message: 'Crédito/Fiado creado exitosamente'
            };
        } catch (error) {
            console.error('❌ Error creando crédito de servicio externo:', error);
            
            let errorMessage = error.message || 'Error al crear crédito';
            if (error.response?.data) {
                if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                } else if (error.response.data.mensaje) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.response.data.errors) {
                    const errors = error.response.data.errors;
                    errorMessage = Object.values(errors).flat().join(', ');
                }
            }
            
            return {
                success: false,
                error: error.message,
                message: errorMessage
            };
        }
    },

    obtenerCreditosPorServicio: async (idServicioExterno) => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/servicio/${idServicioExterno}`);
            return {
                success: true,
                data: response,
                message: 'Créditos obtenidos exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo créditos del servicio:', error);
            return {
                success: false,
                error: error.message,
                data: []
            };
        }
    },

    obtenerCreditosPorCliente: async (idCliente) => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/cliente/${idCliente}`);
            return {
                success: true,
                data: response,
                message: 'Créditos obtenidos exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo créditos del cliente:', error);
            return {
                success: false,
                error: error.message,
                data: []
            };
        }
    },

    registrarPagoCredito: async (idCredito, pago) => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/${idCredito}/pagar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    montoPagoUsd: pago.montoUsd,
                    montoPagoBs: pago.montoBs || 0,
                    fechaPago: pago.fechaPago || new Date().toISOString(),
                    metodoPago: pago.metodoPago || 'Efectivo',
                    referencia: pago.referencia || '',
                    observaciones: pago.observaciones || ''
                })
            });
            return {
                success: true,
                data: response,
                message: 'Pago registrado exitosamente'
            };
        } catch (error) {
            console.error('❌ Error registrando pago de crédito:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    generarCuotasServicioExterno: async (idServicioExterno, numeroCuotas = 1, fechaVencimientoBase = null, observaciones = '') => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/${idServicioExterno}/generar-cuotas`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    idServicioExterno,
                    numeroCuotas,
                    fechaVencimientoBase,
                    observaciones
                })
            });
            return {
                success: true,
                data: response,
                message: `Cuotas generadas exitosamente (${numeroCuotas} cuotas)`
            };
        } catch (error) {
            console.error('❌ Error generando cuotas:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    obtenerCuotasPorServicioExterno: async (idServicioExterno) => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/servicio/${idServicioExterno}/cuotas`);
            return {
                success: true,
                data: response,
                message: 'Cuotas obtenidas exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo cuotas:', error);
            return {
                success: false,
                error: error.message,
                data: []
            };
        }
    },

    pagarCuotaServicioExterno: async (idCuota, pago) => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/cuota/${idCuota}/pagar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    montoUsd: pago.montoUsd,
                    montoBs: pago.montoBs || 0,
                    idUsuario: pago.idUsuario,
                    metodoPago: pago.metodoPago || 'Efectivo',
                    referencia: pago.referencia || '',
                    observaciones: pago.observaciones || ''
                })
            });
            return {
                success: true,
                data: response,
                message: 'Cuota pagada exitosamente'
            };
        } catch (error) {
            console.error('❌ Error pagando cuota:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    obtenerResumenCreditosServiciosExternos: async () => {
        try {
            const response = await apiFetch('/CreditoServicioExterno/resumen');
            return {
                success: true,
                data: response,
                message: 'Resumen obtenido exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo resumen de créditos de servicios externos:', error);
            return {
                success: false,
                error: error.message,
                data: { totalPendiente: 0, totalPagado: 0, totalGeneral: 0, creditos: [] }
            };
        }
    },

    obtenerCreditosVencidos: async () => {
        try {
            const response = await apiFetch('/CreditoServicioExterno/vencidos');
            return {
                success: true,
                data: response,
                message: 'Créditos vencidos obtenidos exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo créditos vencidos:', error);
            return {
                success: false,
                error: error.message,
                data: []
            };
        }
    },

    obtenerResumenCreditoPorServicio: async (idServicioExterno) => {
        try {
            const response = await apiFetch(`/CreditoServicioExterno/resumen/servicio/${idServicioExterno}`);
            return {
                success: true,
                data: response,
                message: 'Resumen obtenido exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo resumen del crédito:', error);
            return {
                success: false,
                error: error.message,
                data: null
            };
        }
    },

    obtenerServiciosConCreditos: async (idCliente = null) => {
        try {
            const url = idCliente 
                ? `/ServiciosExternos/creditos/cliente/${idCliente}`
                : '/ServiciosExternos/creditos/pendientes';
            const response = await apiFetch(url);
            return {
                success: true,
                data: response,
                message: 'Servicios obtenidos exitosamente'
            };
        } catch (error) {
            console.error('❌ Error obteniendo servicios con créditos:', error);
            return {
                success: false,
                error: error.message,
                data: []
            };
        }
    },

    actualizarEstadoCredito: async (id, estadoCredito, idCredito = null) => {
        try {
            const payload = { estadoCredito };
            if (idCredito) {
                payload.idCreditoServicioExterno = idCredito;
            }
            
            const res = await apiFetch(`/ServiciosExternos/${id}/estado-credito`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            return { success: true, data: res };
        } catch (error) {
            console.error("Error en actualizarEstadoCredito:", error);
            return { success: false, message: error.message || 'Error al actualizar estado del crédito' };
        }
    }
};

export const {
    obtenerServicios,
    obtenerServicioPorId,
    crearServicio,
    actualizarServicio,
    eliminarServicio,
    obtenerServiciosConCreditos,
    actualizarEstadoCredito
} = api;

export default api;